/**
 * The prompts generation nodes send, as the user sees and edits them: one
 * sentence per line, with {placeholders} filled for each item. `fillPrompt`
 * turns a template into what's sent.
 */

/** Scene video's first frame, redrawn from the scene's frame with a new person. */
export const SCENE_FRAME_PROMPT = [
  'Recreate the scene in this image as a new photo with a different person - not the one shown.',
  'Keep the setting, pose, framing, camera angle and lighting.',
  'Leave out any text, captions, stickers or logos.',
  'The scene: {scene}',
  'Phone photo, natural and unedited.',
].join('\n');

/** How Scene video's frame moves. */
export const SCENE_MOTION_PROMPT = [
  '{scene}',
  'Natural handheld phone video, realistic motion.',
].join('\n');

/** Persona variations: the scene with the persona's face, one small change per shot. */
export const PERSONA_VARIATION_PROMPT = [
  'Recreate the scene in the first image with the person from the other reference photos - same face, hair, skin tone and build.',
  'Keep the setting, pose, framing and lighting.',
  'Leave out any text, captions or logos.',
  'For this version: {variation}',
].join('\n');

/** The line Persona variations' "Leave out text" toggle takes away (default prompt only). */
export const PERSONA_NO_TEXT_LINE = 'Leave out any text, captions or logos.';

/**
 * A template as sent: each {name} replaced; a line whose placeholder is
 * empty is dropped (a scene with no description); lines joined with spaces.
 */
export function fillPrompt(
  template: string,
  vars: Record<string, string | null | undefined>,
) {
  return template
    .split('\n')
    .map((line) => {
      let empty = false;
      const filled = line.replace(/\{(\w+)\}/g, (match, name: string) => {
        if (!(name in vars)) return match;
        const value = vars[name]?.trim();
        if (!value) empty = true;
        return value ?? '';
      });
      return empty ? '' : filled.trim();
    })
    .filter(Boolean)
    .join(' ');
}
